import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { addData, deleteData, loadData, updateData } from "../../../../config/data";
import EmptyAsset from "../emptyAsset";
import Lang from "../../../../config/lang";
import { useProfileTab } from "../../ProfileTabContext";

const ProfessionalReferencesForm = ({ setIsFading, updatePercentage, profileCompletion  }) => {
  const { lang } = useSelector((state) => state.globalReducer);
  const { currentTabIndex, setCurrentTabIndex } = useProfileTab();

  const [isEdit, setIsEdit] = useState(false);
  const [references, setReferences] = useState([]);
  const [isLoading, setisLoading] = useState('');
  const applicantID = localStorage?.getItem("applicantID");
  const userToken = localStorage?.getItem('authToken') || '';

  const loadReferences = async () => {
    loadData({
      url: "OtherReferences",
      params: [{ title: "filter", value: `applicant:${applicantID}` }],
      userToken,
    }).then((res) => {
      if (res?.data) {
        setReferences(res.data);
      }
    });
  };

  useEffect(() => {
    loadReferences();
  }, []);


  const isFormReady = () => {
    const hasEmptyId = references.some(item => !item.referenceFullName || !item.referencePosition || !item.referenceCompanyName || !item.referencePhoneNumber || !item.relationship);
    return !hasEmptyId;
  }


  const handleChange = (index, field, value) => {
    const updated = [...references];
    updated[index][field] = value;
    setReferences(updated);
  };

  const handleAdd = () => {
    setIsEdit(true);
    setReferences([
      ...references,
      {
        otherReferenceID: undefined,
        applicantID,
        referenceFullName: "",
        referencePosition: "",
        relationship: "",
        referenceCompanyName: "",
        referencePhoneNumber: "",
        referenceAddress: "",
      },
    ]);
  };

  const saveReference = async (ref) => {
    try {
      const body = {
        otherReferenceID: ref.otherReferenceID || undefined,
        applicantID,
        referenceFullName: ref.referenceFullName,
        referencePosition: ref.referencePosition,
        relationship: ref.relationship,
        referenceCompanyName: ref.referenceCompanyName,
        referencePhoneNumber: ref.referencePhoneNumber,
        referenceAddress: ref.referenceAddress,
      };

      if (ref.otherReferenceID) {
        await updateData({ url: "OtherReferences", reqBody: body, userToken });
      } else {
        await addData({ url: "OtherReferences", reqBody: body, userToken });
      }
    } catch (err) {
      console.error("Failed to save reference:", err);
    }
  };

  const handleSave = async () => {
    setisLoading(true);
    for (const ref of references) {
      await saveReference(ref);
    }
    setIsEdit(false);
    loadReferences();
    setisLoading(false);
  };

  const handleDelete = async (index, ref) => {
    try {
      if (ref.otherReferenceID) {
        await deleteData({ url: "OtherReferences", id: ref.otherReferenceID, userToken });
      }
      setReferences(references.filter((_, i) => i !== index));
    } catch (err) {
      console.error("Failed to delete reference:", err);
    }
  };

  return (
    <div>

    <div className="mt-4 bg-white p-6 rounded-xl shadow-[0px_1px_2px_rgba(0,0,0,0.05)]" style={{minHeight:window.innerHeight-300}}>
      <div className="flex justify-between items-center mb-4">
        <div className="flex-1">
            <h2 className="text-blue-700 font-medium md:text-[20px] text-[17px] flex items-center space-x-2 cursor-pointer">
              <img src={"/asset/icon/job_blue.svg"} className="w-[16px] mr-1" />
              <span>{Lang(lang, 'professional_references')}</span>
            </h2>
            <p className="text-[11px] md:text-[14px] font-normal text-[#1E3A8A]">{Lang(lang, 'pref_subtitle')}</p>
          </div>
        {!isEdit && (
          <button
            onClick={() => setIsEdit(true)}
            className="flex border border-gray-300 rounded-full px-5 py-2 text-sm text-white bg-red-500 hover:bg-red-600"
          >
            <img src={"/asset/icon/edit.svg"} className="w-[16px] mr-1" />
            Edit
          </button>
        )}
      </div>

      <form className="space-y-6">
        {references.length === 0 ? (
          <div className="w-full">
            <EmptyAsset
              title={Lang(lang, "no_references")}
              desc={Lang(lang, "no_references_desc")}
            />
            {isEdit && <button
              type="button"
              onClick={handleAdd}
              className="w-full text-blue-600 border border-dashed border-blue-300 rounded-full py-2 text-sm hover:bg-blue-50 mb-4"
            >
              + {Lang(lang, "professional_references")}
            </button>}
          </div>
        ) : (
          references.map((ref, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-xl p-4 relative"
            >
              {isEdit && (
                <button
                  type="button"
                  onClick={() => handleDelete(index, ref)}
                  className="absolute top-3 right-3 text-red-500 hover:text-red-700"
                >
                  <img src={"/asset/icon/trash.svg"} className="w-[16px]" />
                </button>
              )}

              <h3 className="text-gray-700 font-bold mb-3">
                {Lang(lang,"reference")} {index + 1}
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                <div>
                  <label className="block font-medium mb-1">{Lang(lang, 'company')}<span className="text-red-500">*</span></label>
                  <input
                    disabled={!isEdit}
                    type="text"
                    value={ref.referenceCompanyName || ""}
                    onChange={(e) =>
                      handleChange(index, "referenceCompanyName", e.target.value)
                    }
                    className={(isEdit?'bg-white':'bg-gray-100')+ " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                    placeholder="Company Name"
                  />
                </div>

                <div>
                  <label className="block font-medium mb-1">{Lang(lang, 'name_of_reference')}<span className="text-red-500">*</span></label>
                  <input
                    disabled={!isEdit}
                    type="text"
                    value={ref.referenceFullName || ""}
                    onChange={(e) =>
                      handleChange(index, "referenceFullName", e.target.value)
                    }
                    className={(isEdit?'bg-white':'bg-gray-100')+ " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                    placeholder="Full Name"
                  />
                </div>

                <div>
                  <label className="block font-medium mb-1">{Lang(lang, 'role_or_position')}<span className="text-red-500">*</span></label>
                  <input
                    disabled={!isEdit}
                    type="text"
                    value={ref.referencePosition || ""}
                    onChange={(e) =>
                      handleChange(index, "referencePosition", e.target.value)
                    }
                    className={(isEdit?'bg-white':'bg-gray-100')+ " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                    placeholder="Position"
                  />
                </div>

                <div>
                  <label className="block font-medium mb-1">{Lang(lang, 'contact_references')}<span className="text-red-500">*</span></label>
                  <input
                    disabled={!isEdit}
                    type="number"
                    value={ref.referencePhoneNumber || ""}
                    onChange={(e) =>
                      handleChange(index, "referencePhoneNumber", e.target.value)
                    }
                    className={(isEdit?'bg-white':'bg-gray-100')+ " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                    placeholder="Phone Number"
                  />
                </div>

                <div>
                  <label className="block font-medium mb-1">{Lang(lang, 'relationship')}<span className="text-red-500">*</span></label>
                  <div className="flex flex-row gap-4 mt-7">
                    <label className="flex items-center gap-1">
                      <input
                        disabled={!isEdit}
                        type="radio"
                        checked={ref.relationship === "Atasan"}
                        onChange={() =>
                          handleChange(index, "relationship", "Atasan")
                        }
                      />
                      Atasan
                    </label>
                    <label className="flex items-center gap-1">
                      <input
                        disabled={!isEdit}
                        type="radio"
                        checked={ref.relationship === "HRD/Personalia"}
                        onChange={() =>
                          handleChange(index, "relationship", "HRD/Personalia")
                        }
                      />
                      HRD/Personalia
                    </label>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}

        {isEdit && references.length !== 0 && (
          <button
            type="button"
            onClick={handleAdd}
            className="w-full text-blue-600 border border-dashed border-blue-300 rounded-full py-2 text-sm hover:bg-blue-50 mb-4"
          >
            + {Lang(lang, "professional_references")}
          </button>
        )}
      </form>

      {!(isFormReady()) && <div className="flex justify-end w-full mb-2">
        <p className="text-red-500 text-xs mt-1 mr-0">{Lang(lang, 'required_error')}</p>
      </div>}

      
    </div>
    <div className="flex space-x-2 mt-3 justify-end w-full bg-white shadow-[0px_1px_2px_rgba(0,0,0,0.05)] p-3 rounded-xl sticky bottom-3">
        <button
          type="button"
          className="border border-gray-300 rounded-full px-4 py-1 text-sm hover:bg-gray-50"
          onClick={() => {
            setIsFading(true);
            setTimeout(() => {
              setCurrentTabIndex(currentTabIndex - 1);
              setIsFading(false);
            }, 200);
          }}
        >
          {Lang(lang, 'previous')}
        </button>
        <button
          type="button"
          className={
            "rounded-full px-4 py-1 text-sm " +
            (isEdit && isFormReady()
              ? "text-white bg-red-500 hover:bg-red-600"
              : "border border-red-500 text-red-500 hover:bg-gray-50")
          }
          onClick={async () => {
            if (isFormReady()) {
              if (isEdit && !isLoading) {
                await handleSave();
              }
              setIsFading(true);
              setTimeout(() => {
                  if ((currentTabIndex + 1) > profileCompletion) {
                    updatePercentage(currentTabIndex + 1)
                  }
                setCurrentTabIndex(currentTabIndex + 1);
                setIsFading(false);
              }, 200);
            }
          }}
        >
          {isLoading ? <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto" /> : isEdit ? Lang(lang, 'save_and_next') : `${Lang(lang, 'next')} ${currentTabIndex + 1}/10`}
        </button>
      </div>
    </div>
  );
};

export default ProfessionalReferencesForm;
